// Indian numbering formatter: 1,00,000 (lakh), 1,00,00,000 (crore)
export function formatINR(value, { decimals = 2, withSymbol = true } = {}) {
  if (value === null || value === undefined || value === "" || Number.isNaN(Number(value))) return "—";
  try {
    const fmt = new Intl.NumberFormat("en-IN", {
      style: withSymbol ? "currency" : "decimal",
      currency: "INR",
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    return fmt.format(Number(value));
  } catch {
    return String(value);
  }
}

// Compact Indian formatter for large sums: ₹1,755.31 Cr / ₹12.50 L / ₹45.00 K.
// Crore (≥1 Cr), Lakh (≥1 L), Thousand (≥1 K); below ₹1,000 shows the full value.
export function formatINRCompact(value, { withSymbol = true, decimals = 2 } = {}) {
  if (value === null || value === undefined || value === "" || Number.isNaN(Number(value))) return "—";
  const n = Number(value);
  const abs = Math.abs(n);
  const sym = withSymbol ? "₹" : "";
  const grouped = (x) =>
    new Intl.NumberFormat("en-IN", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(x);
  if (abs >= 1e12) return `${sym}${grouped(n / 1e12)} L Cr`;   // lakh-crore — keeps huge sums short
  if (abs >= 1e7) return `${sym}${grouped(n / 1e7)} Cr`;
  if (abs >= 1e5) return `${sym}${grouped(n / 1e5)} L`;
  if (abs >= 1e3) return `${sym}${grouped(n / 1e3)} K`;
  return formatINR(n, { withSymbol, decimals });
}

export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(value));
}

export function formatPct(value, decimals = 2) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return `${Number(value).toFixed(decimals)}%`;
}
